import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import GlobalStyles from '@tt/assets/styles/globalStyle';
import { store } from './redux/store';
import Boot from './redux/boot';
import Routes from './router';
import ConsentModal from './components/consent/ConsentModal';
import AppProvider from './AppProvider';
import { CONSTANT_VARIABLES } from './views/common/Constant_Variables/constants';
import { getEnvDetail } from './utils/env';
const envDetail = getEnvDetail();

function appendWhatFixToPortal() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = envDetail.name == 'local' ? CONSTANT_VARIABLES.WHATFIX_LOCAL_SRC : CONSTANT_VARIABLES.WHATFIX_CLIENT_SRC;
  document.head.appendChild(script);
}
appendWhatFixToPortal();
const App = () => {
  const [consentGiven, setConsentGiven] = useState(() => {
    try {
      return localStorage.getItem('privacyConsent') === '1';
    } catch (e) {
      return false;
    }
  });
  const [consentDismissed, setConsentDismissed] = useState(false);

  useEffect(() => {
    if (consentGiven) {
      try {
        localStorage.setItem('privacyConsent', '1');
      } catch (e) {
        // ignore
      }
    }
  }, [consentGiven]);

  return (
    <Provider store={store}>
      <AppProvider>
        <>
          <GlobalStyles />
          {!consentGiven && (
            <ConsentModal
              dismissedButBlurred={consentDismissed}
              onAccept={() => {
                console.log('Consent accepted');
                setConsentGiven(true);
              }}
              onReject={() => {
                // Keep the overlay/blur visible but hide the dialog content
                console.log('Consent rejected for this session');
                setConsentDismissed(true);
              }}
            />
          )}
          <Routes />
        </>
      </AppProvider>
    </Provider>
  );
};
Boot()
  .then(() => App())
  .catch(error => console.error(error));

export default App;
